import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-spinner-animation',
  templateUrl: './spinner.animation.html',
  styleUrls: ['./spinner.animation.scss']
})
export class SpinnerAnimation implements OnInit {

  @Input() message = '';

  constructor() { }

  ngOnInit() {
  }
}